/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import Term from 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CalculatorTerms/Term.jsx';
import * as Actions from 'payment-calculator-v25/actions/paymentCalculatorActions.js';
import { PurchaseMethodsV25, CurrencyFormats, Quote } from '@sm360/widget-commons-vehicle';

import 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CalculatorTerms/CalculatorTerms.scss';

class CalculatorTerms extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(value) {
        this.props.actions.selectTerm(value, this.props.config);
        AnalyticsService.ga4Trigger(
            TAGS.PAYMENT_CALCULATOR_DURATION(value, this.props.quote.vehicle.model.name, this.props.quote.vehicle.year)
        );
    }
    render() {
        const { purchaseMethods } = this.props;
        const selectedTerm = purchaseMethods.getSelectedFinanceTerm();
        const { cashDown } = purchaseMethods;
        const { cashDownOptions } = purchaseMethods.getCalculatorOptions() || {};
        const terms = cashDownOptions ? cashDownOptions.find((option) => option.cashDown === cashDown)?.terms : [];
        const paymentFrequencyLabels = purchaseMethods.getPaymentFrequencyLabels(LocaleService);
        const termsBlock = terms?.map((term) => {
            return (
                <Term
                    key={term.term}
                    paymentFrequencyLabels={paymentFrequencyLabels}
                    payment={LocaleService.l(term.payment, CurrencyFormats.CURRENCY_2)}
                    term={term.term}
                    apr={!term?.creditRate || !this.props.displayCreditRate ? term.apr : term?.creditRate}
                    handleClick={this.handleClick}
                    selectedTerm={selectedTerm}
                    purchaseMethods={this.props.purchaseMethods}
                    config={this.props.config}
                    displayCreditRate={this.props.displayCreditRate}
                />
            );
        });

        return <div className="calculator-terms clearfix">{termsBlock}</div>;
    }
}

CalculatorTerms.defaultProps = {
    displayCreditRate: false,
};
CalculatorTerms.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    actions: PropTypes.shape({
        selectTerm: PropTypes.func.isRequired,
    }),
    displayCreditRate: PropTypes.bool,
};

CalculatorTerms.displayName = 'CalculatorTerms';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethodsV25,
        quote: state.quoteV25,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CalculatorTerms);
export { CalculatorTerms };
